import {gql} from "@apollo/client";

const PAYMENT_LIST= gql`
subscription MovmentsWallet {
    clubmate_clubmatewallet_movementwallet(order_by: {datetime: desc}) {
        id
        quantity
        datetime
        clubmatewallet_clubmatewallet{
          id
          usersregister_userregisters{
            id
            name
            surname
            fiscal_code
          }
        }
        clubmateservice_clubmateservice{
            id
            name
        }
        clubmatepackage_clubmatepackage{
          id
          name
        }
    }
}
`

export {PAYMENT_LIST}